/**
 * Top ~500 U.S. cities by population.
 * Source: U.S. Census Bureau estimates (top-by-population list, condensed).
 * Encoded compactly as "name|ST" rows to keep the bundle small.
 */

import { US_STATES } from "@/lib/us-states";

export type UsCity = { name: string; state: string };

// City|State, one per line, ordered roughly by population (largest first).
const RAW = `
New York|NY
Los Angeles|CA
Chicago|IL
Houston|TX
Phoenix|AZ
Philadelphia|PA
San Antonio|TX
San Diego|CA
Dallas|TX
Jacksonville|FL
Austin|TX
Fort Worth|TX
San Jose|CA
Columbus|OH
Charlotte|NC
Indianapolis|IN
San Francisco|CA
Seattle|WA
Denver|CO
Washington|DC
Nashville|TN
Oklahoma City|OK
El Paso|TX
Boston|MA
Portland|OR
Las Vegas|NV
Detroit|MI
Memphis|TN
Louisville|KY
Baltimore|MD
Milwaukee|WI
Albuquerque|NM
Tucson|AZ
Fresno|CA
Sacramento|CA
Mesa|AZ
Kansas City|MO
Atlanta|GA
Omaha|NE
Colorado Springs|CO
Raleigh|NC
Long Beach|CA
Virginia Beach|VA
Miami|FL
Oakland|CA
Minneapolis|MN
Tulsa|OK
Bakersfield|CA
Wichita|KS
Arlington|TX
Aurora|CO
Tampa|FL
New Orleans|LA
Cleveland|OH
Anaheim|CA
Honolulu|HI
Henderson|NV
Stockton|CA
Lexington|KY
Corpus Christi|TX
Riverside|CA
Santa Ana|CA
Orlando|FL
Irvine|CA
Cincinnati|OH
Newark|NJ
Saint Paul|MN
Pittsburgh|PA
Greensboro|NC
St. Louis|MO
Lincoln|NE
Plano|TX
Anchorage|AK
Durham|NC
Jersey City|NJ
Chandler|AZ
Chula Vista|CA
Buffalo|NY
North Las Vegas|NV
Gilbert|AZ
Madison|WI
Reno|NV
Toledo|OH
Fort Wayne|IN
Lubbock|TX
St. Petersburg|FL
Laredo|TX
Irving|TX
Chesapeake|VA
Glendale|AZ
Winston-Salem|NC
Port St. Lucie|FL
Scottsdale|AZ
Garland|TX
Boise|ID
Norfolk|VA
Spokane|WA
Fremont|CA
Richmond|VA
Santa Clarita|CA
San Bernardino|CA
Baton Rouge|LA
Hialeah|FL
Tacoma|WA
Modesto|CA
Huntsville|AL
Des Moines|IA
Frisco|TX
Yonkers|NY
Rochester|NY
Moreno Valley|CA
Fontana|CA
Columbus|GA
McKinney|TX
Fayetteville|NC
Worcester|MA
Salt Lake City|UT
Cape Coral|FL
Little Rock|AR
Amarillo|TX
Augusta|GA
Oxnard|CA
Birmingham|AL
Montgomery|AL
Overland Park|KS
Grand Rapids|MI
Tallahassee|FL
Huntington Beach|CA
Sioux Falls|SD
Peoria|AZ
Knoxville|TN
Glendale|CA
Vancouver|WA
Providence|RI
Akron|OH
Brownsville|TX
Mobile|AL
Newport News|VA
Tempe|AZ
Shreveport|LA
Chattanooga|TN
Fort Lauderdale|FL
Aurora|IL
Elk Grove|CA
Ontario|CA
Salem|OR
Cary|NC
Santa Rosa|CA
Rancho Cucamonga|CA
Eugene|OR
Oceanside|CA
Clarksville|TN
Garden Grove|CA
Lancaster|CA
Springfield|MO
Pembroke Pines|FL
Fort Collins|CO
Palmdale|CA
Salinas|CA
Hayward|CA
Corona|CA
Paterson|NJ
Murfreesboro|TN
Macon|GA
Lakewood|CO
Killeen|TX
Springfield|MA
Alexandria|VA
Kansas City|KS
Sunnyvale|CA
Hollywood|FL
Roseville|CA
Charleston|SC
Escondido|CA
Joliet|IL
Jackson|MS
Bellevue|WA
Surprise|AZ
Naperville|IL
Pasadena|TX
Pomona|CA
Bridgeport|CT
Denton|TX
Rockford|IL
Mesquite|TX
Savannah|GA
Syracuse|NY
McAllen|TX
Torrance|CA
Olathe|KS
Visalia|CA
Thornton|CO
Fullerton|CA
Gainesville|FL
Waco|TX
West Valley City|UT
Warren|MI
Lakewood|NJ
Hampton|VA
Dayton|OH
Columbia|SC
Orange|CA
Cedar Rapids|IA
Stamford|CT
Victorville|CA
Pasadena|CA
Elizabeth|NJ
New Haven|CT
Miramar|FL
Kent|WA
Sterling Heights|MI
Nashua|NH
Carrollton|TX
Coral Springs|FL
Midland|TX
Norman|OK
Athens|GA
Santa Clara|CA
Columbia|MO
Fargo|ND
Pearland|TX
Simi Valley|CA
Topeka|KS
Meridian|ID
Allentown|PA
Thousand Oaks|CA
Abilene|TX
Vallejo|CA
Concord|CA
Round Rock|TX
Arvada|CO
Clovis|CA
Palm Bay|FL
Independence|MO
Lafayette|LA
Ann Arbor|MI
Rochester|MN
Hartford|CT
College Station|TX
Fairfield|CA
Wilmington|NC
North Charleston|SC
Billings|MT
West Palm Beach|FL
Berkeley|CA
Cambridge|MA
Clearwater|FL
West Jordan|UT
Evansville|IN
Richardson|TX
Broken Arrow|OK
Richmond|CA
League City|TX
Manchester|NH
Lakeland|FL
Carlsbad|CA
Antioch|CA
Westminster|CO
High Point|NC
Provo|UT
Lowell|MA
Elgin|IL
Waterbury|CT
Springfield|IL
Gresham|OR
Murrieta|CA
Lewisville|TX
Las Cruces|NM
Lansing|MI
Beaumont|TX
Odessa|TX
Pueblo|CO
Peoria|IL
Downey|CA
Pompano Beach|FL
Miami Gardens|FL
Temecula|CA
Everett|WA
Costa Mesa|CA
San Buenaventura|CA
Sparks|NV
Santa Maria|CA
Sugar Land|TX
Greeley|CO
South Fulton|GA
Dearborn|MI
Concord|NC
Tyler|TX
Sandy Springs|GA
West Covina|CA
Green Bay|WI
Centennial|CO
Jurupa Valley|CA
El Monte|CA
Allen|TX
Hillsboro|OR
Menifee|CA
Nampa|ID
Spokane Valley|WA
Rio Rancho|NM
Brockton|MA
El Cajon|CA
Burbank|CA
Inglewood|CA
Renton|WA
Davie|FL
Rialto|CA
Boulder|CO
South Bend|IN
Woodbridge|NJ
Vacaville|CA
Edinburg|TX
Wichita Falls|TX
Quincy|MA
Davenport|IA
Carmel|IN
Westminster|CA
Roanoke|VA
Erie|PA
Lynn|MA
North Richland Hills|TX
Norwalk|CA
Tuscaloosa|AL
Daly City|CA
Lakewood|CA
Fishers|IN
Greenville|NC
Tracy|CA
Clinton|MI
Lee's Summit|MO
Chico|CA
Greenville|SC
San Mateo|CA
Sandy Springs|GA
New Bedford|MA
Champaign|IL
Lawton|OK
Suffolk|VA
Federal Way|WA
Newton|MA
Compton|CA
San Angelo|TX
Bend|OR
Clifton|NJ
Mission Viejo|CA
Yuma|AZ
Trenton|NJ
Citrus Heights|CA
Conroe|TX
Bryan|TX
Vista|CA
Rogers|AR
Mission|TX
Goodyear|AZ
Bloomington|MN
Indio|CA
Folsom|CA
Livonia|MI
Camden|NJ
Albany|NY
Hawthorne|CA
Waukegan|IL
Bloomington|IL
Buckeye|AZ
Hemet|CA
Edmond|OK
Beaverton|OR
Whittier|CA
South Gate|CA
Lehi|UT
Lynchburg|VA
Brooklyn Park|MN
Plantation|FL
Asheville|NC
Schaumburg|IL
San Marcos|CA
Pharr|TX
Livermore|CA
Sunrise|FL
Doral|FL
Largo|FL
Bethlehem|PA
Bolingbrook|IL
Boca Raton|FL
Missoula|MT
Mountain View|CA
Layton|UT
Tustin|CA
Idaho Falls|ID
Hesperia|CA
Flower Mound|TX
Lakeland|FL
Deerfield Beach|FL
San Marcos|TX
Roswell|GA
Reading|PA
Alameda|CA
Yakima|WA
Decatur|IL
Westland|MI
Brockton|MA
Auburn|WA
Eagan|MN
Buena Park|CA
Tamarac|FL
Pawtucket|RI
Springdale|AR
Sunrise Manor|NV
Sandy|UT
Norwalk|CT
Hoover|AL
Sioux City|IA
Plymouth|MN
Paradise|NV
Spring Valley|NV
Catalina Foothills|AZ
Mountain Brook|AL
Bellingham|WA
Joplin|MO
Rocklin|CA
Yorba Linda|CA
Schenectady|NY
Auburn|AL
Brentwood|CA
Apple Valley|CA
Frederick|MD
Lakewood|WA
Maple Grove|MN
San Clemente|CA
Pleasanton|CA
Decatur|AL
Bayonne|NJ
Lake Forest|CA
Bristol|CT
Mount Pleasant|SC
Largo|MD
Galveston|TX
Edina|MN
Janesville|WI
Bowling Green|KY
Redding|CA
Margate|FL
Conway|AR
Rock Hill|SC
Coon Rapids|MN
Union City|CA
Manteca|CA
Eden Prairie|MN
Wylie|TX
Iowa City|IA
La Habra|CA
Camarillo|CA
Pflugerville|TX
Pinellas Park|FL
Cuyahoga Falls|OH
Smyrna|GA
Coral Gables|FL
Olympia|WA
Mansfield|TX
Oshkosh|WI
Castle Rock|CO
Bellflower|CA
North Port|FL
Encinitas|CA
Lake Charles|LA
Hendersonville|TN
Hilton Head Island|SC
Apex|NC
Pittsburg|CA
Bismarck|ND
Casper|WY
Cheyenne|WY
Burlington|VT
Dover|DE
Wilmington|DE
Annapolis|MD
Portland|ME
Lewiston|ME
Bangor|ME
Charleston|WV
Huntington|WV
Morgantown|WV
`;

export const US_CITIES: UsCity[] = RAW.trim()
  .split("\n")
  .map((line) => {
    const [name, state] = line.split("|");
    return { name: name.trim(), state: state.trim() };
  });

const STATE_CODES = new Set(US_STATES.map((s) => s.code));
// Filter out any stray rows whose state code is unknown, and dedupe by
// (name, state) so accidental repeats in RAW don't break React keys.
const seen = new Set<string>();
export const US_CITIES_VALID = US_CITIES.filter((c) => {
  if (!STATE_CODES.has(c.state)) return false;
  const k = `${c.name}|${c.state}`;
  if (seen.has(k)) return false;
  seen.add(k);
  return true;
});

export function citiesInState(stateCode: string): UsCity[] {
  return US_CITIES_VALID.filter((c) => c.state === stateCode);
}
